/**
 * ==========================> MAIN AI ROUTINE <=============================
 * 
 * TODO: PROPERLY RE-PARTITION THIS CODE AND CLEAN IT UP
 * 
 */

import * as dat from 'dat.gui';     // need to npm install
import { isMobile, 
         toggleLoadingUI, 
         tryResNetButtonName, 
         tryResNetButtonText, 
         updateTryResNetButtonDatGuiCss,
         drawBoundingBox,
         drawKeypoints,
         drawSkeleton,
         drawFaceMask,
         renderImageToCanvas,
       } from './demoUtil';
import { yoloPostProcess,
         yoloCorrectBoxes
       } from './yoloPostProcess';
import { initWebcamAI,
         setupVideoFile,
         stopVideo,
         recordOutput,
       } from '../util/videoUtil';
import { performFrameAnalysis,
         storePoseData, 
         storeBallData, 
         batchAnalysis } from '../util/analysis'

import { displayGridLines } from '../util/annotate'
import { CONSTS, HISTORY,
         INFO,
		 TIMES,
         } from '../util/object'
import { timeDelta,
         showLoadingMessage,
         NOW,
         } from '../util/util'
import { initVideoDisplay} from '../util/annotate'
import * as Reset from 'gl-reset';      // reset webGL stuff, not working too good
import { TFMem } from '../util/tools'
import { setFrameEvent,
		 } from '../util/util'
import { instanceOf } from 'prop-types';

// POSE DETECTION MODEL STUFF
//import * as posenet from '@tensorflow-models/posenet';
import * as poseDetection from '@tensorflow-models/pose-detection';     // for new Movenet
import * as tf from '@tensorflow/tfjs';       // need tfjs for loadGraphModel
import '@tensorflow/tfjs-backend-webgl';
import * as scatter from 'scatter-gl';


//import * as tf from '@tensorflow/tfjs-core';
//import * as poseDetection from '@tensorflow-models/pose-detection';
//import '@tensorflow/tfjs-backend-webgl';
//import * as tfconv from '@tensorflow/tfjs-converter';
//import { setWasmPaths } from '@tensorflow/tfjs-backend-wasm';
//import '@tensorflow/tfjs-backend-webgpu';      // mar-2021: not quite ready yet
//import * as tfjsWasm from '@tensorflow/tfjs-backend-wasm';
//tfjsWasm.setWasmPath('https://cdn.jsdelivr.net/npm/@tensorflow/tfjs-backend-wasm@latest/dist/tfjs-backend-wasm.wasm');
//tfjsWasm.setWasmPaths(`https://cdn.jsdelivr.net/npm/@tensorflow/tfjs-backend-wasm@${tfjsWasm.version_wasm}/dist/`);
//import * as cocoSSD from '@tensorflow-models/coco-ssd';     // SSD object detect

import * as mpPose from '@mediapipe/pose';



//import * as tfjsWasm from '@tensorflow/tfjs-backend-wasm';      // NOTE: *** MUST HAVE THIS FOR MEDIAPIPE!
//tfjsWasm.setWasmPaths( `https://cdn.jsdelivr.net/npm/@tensorflow/tfjs-backend-wasm@${tfjsWasm.version_wasm}/dist/`);



var POSE_MODEL;
var gui;

var images = [ ]
var my_classes = null       // KLUDGE: global
var directory = null;
var imageBucket = 'assets/images/bo-wk3-prog/';
var last_timestamp = performance.now();


// KLUDGE: should live in config
const v3_masks = {
    "3": [[6, 7, 8], [3, 4, 5], [0, 1, 2]],
    "2": [[3, 4, 5], [0, 1, 2]]        // to match darknet.cfg
};
const v3_tiny_anchors = [
  10,14, 23,27, 37,58, 81,82, 135,169, 344,319
];


const SOCCER_MODEL = true;
//const SOCCER_MODEL = false;
//const sk_color1 = '#42b21840';  // '#42b218a8';  //MAIN: skeleton color 'aqua';
//const sk_color2 = 'rgba(0,255,255,1)';  //solid skeleton color 'aqua';
//const sk_color3 = 'rgba(0,255,0,1)';  // dev_mode: green
//const SCORE_THRESHOLD = .001;  // .5;
const SCORE_THRESHOLD = .08;  // .5;

//const POSE_INPUT_SIZE = 192;
const MAX_BOXES = 20;
const YOLO_INPUT_SIZE = 416;
const POSE_INPUT_SIZE = 256;
const IOU_THRESHOLD = .3;    // .3

//const defaultQuantBytes = 4;
//const defaultMobileNetMultiplier = isMobile() ? 0.50 : 0.75;    // 0.75
//const defaultMobileNetMultiplier = isMobile() ? 0.50 : 1.0;    // 0.75
//const defaultMobileNetStride = 16;      // can not be 32
//const defaultMobileNetInputResolution = 513;    // 257, 513
const defaultQuantBytes = 2;    // QuantByte @1 does NOT WORK!
const defaultMobileNetMultiplier = isMobile() ? 0.50 : 0.50;    // 0.75
const defaultMobileNetStride = 8;      // can not be 32
const defaultMobileNetInputResolution = 257;    // 257, 513
const defaultPoseConfidence = 0.8;      // KLUDGE: MOVE TO INFO   0.3
const defaultPartConfidence = 0.5;      // KLUDGE: MOVE TO INFO   0.5

const defaultResNetMultiplier = 1.0;
const defaultResNetStride = 32;
const defaultResNetInputResolution = 257;

const soccer_classes = [
  'soccer',
  'cone'
];


///////////////////////////// MOVE BELOW TO POSE-DRAW?  ///////////////////////////////////////////////////
/**
 * Draws a pose if it passes a minimum confidence onto a canvas.
 * Only the pose's keypoints that pass a minPartConfidence are drawn.
 */
export function drawResults(canvas, image, poses, minPartConfidence, minPoseConfidence, lineWidth) {
    if(!image || !canvas) {console.log("draw.132:  BAD IMAGE or CANVAS! canvas=",canvas); return};

    var ocanvas = document.getElementById("output");        // output canvas
    const ctx = canvas.getContext('2d');

    //console.log("drawResults.159: ***** START drawResult()  canvas0=", canvas0, " canvas=",canvas);
    switch (image.constructor.name) {
        case 'HTMLVideoElement':
            //canvas.width = parseInt(image.videoWidth);       // NOTE: BAD!  this wipes out the video image for replay
            //canvas.height = parseInt(image.videoHeight);
            //console.log("drawResults.183: ***** DETECTED VIDEO=  v.wd=", canvas.width, " c.ht=",canvas.height, "  v.wd=", image.videoWidth, " v.ht=",image.videoHeight);
            var wd = canvas.width;
            var ht = canvas.height;
            var vwd = image.videoWidth;
            var vht = image.videoHeight;
            var swd = image.style.width;
            var sht = image.style.height;
            //console.log("draw.169:   Video.drawResults()    wd=", wd, " ht=",ht," vwd=",vwd," vht=",vht, " swd=",swd," sht=",sht);
            break;

        case "HTMLImageElement":
        case "SVGImageElement":
        case "ImageBitmap":
        case "HTMLCanvasElement":
            //canvas.width = parseInt(image.width);
            //canvas.height = parseInt(image.height);
            var wd = canvas.width;
            var ht = canvas.height;
            var iwd = image.width;
            var iht = image.height;
            var swd = image.style.width;
            var sht = image.style.height;
            //console.log("draw.175:   Image.drawResults()    wd=", wd, " ht=",ht," iwd=",iwd," iht=",iht, " swd=",swd," sht=",sht);
            break;

        default:
            console.log("ERROR: Unsupported format...", image.constructor.name);
            return;
    }

    // OUTPUT ANNOTATED IMAGE TO "output" canvas
    //
    //if((canvas !== null) && (canvas.width > 0)) {
    if(canvas !== null) {
        //console.log("draw.157:  output.w=", canvas.width, "  output.h=",canvas.height, "  img.w=",image.width, " img.h=",image.height,"  canvas.w=",canvas.width, " canvas.h=",canvas.height);
        //canvas.width = canvas.width;
        //canvas.height = canvas.height;
        //displayGridLines();

        var color = (INFO.analysis_canvas == "yolo") ? CONSTS.COLOR_SKELETON_YOLO : (INFO.dev_analyze_mode === true) ? CONSTS.COLOR_SKELETON_DEV : CONSTS.COLOR_SKELETON_MAIN;
        var linew = (INFO.analysis_canvas == "yolo") ? 2 : lineWidth; 
        //console.log("***** POSE.OUTPUT pose=", poses, "  image=", image, " color=", color);
        if ((poses !== null) && (poses !== undefined) && (INFO.use_movenet === true) || (INFO.use_blazepose === true)) {

            //console.log("163:  poses=",poses[0]);
            drawMovenetResult(canvas, ctx, poses, minPoseConfidence, color);

        } else {
            poses.forEach((pose) => {
                if ((pose.keypoint !== undefined) && (Object.keys(INFO.idx).length === 0)) {
                    collectKeypointIndex(pose.keypoints);
                }
                if (pose.score >= minPoseConfidence) {
                    //console.log("drawResults.180:    OLD pose.score=",pose.score);
                    if (guiState.showKeypoints) {
                        drawKeypoints(pose.keypoints, minPartConfidence, ctx, color);
                    }

                    if (guiState.showSkeleton) {
                        drawSkeleton(pose.keypoints, minPartConfidence, ctx, linew, color);
                    }

                    if (guiState.showBoundingBox) {
                        drawBoundingBox(pose.keypoints, ctx);
                    }

                    // OLD: hide player face
                    var show_facemask = false;
                    if (show_facemask === true) {
                        drawFaceMask(pose.keypoints, ctx);
                    }
                }
            });
        }

        // NEED TO DO THIS LATER!
        //renderImageToCanvas(canvas, [ocanvas.width, ocanvas.height], ocanvas); // transfer output to display canvas
        //renderImageToCanvas(image, [ocanvas.width, ocanvas.height], ocanvas); // always display image in output, overlay canvas is passed in
    } else {
        console.log("drawResults.221: no canvas set  canvas=",canvas)
    }

    //TFMem("drawResults");
}


/////////////////////// BELOW ARE MOVENET ROUTINES ///////////////////////
// 2021: BEST VERSION OF MODEL
// SRC: https://www.tensorflow.org/hub/tutorials/movenet
//

 const DEFAULT_RADIUS = 1;      // 2
 const DEFAULT_LINE_WIDTH = 1;      // 3;
 //const SCORE_THRESHOLD = 0.4;


// collect keypoint features and put into INFO.idx hash
// NOTE: Has matching in APS:axo-util.js
// src: https://www.tensorflow.org/lite/examples/pose_estimation/overview
function collectKeypointIndex(keypoints) {
    if ((keypoints === null) || (keypoints === undefined)) {
        return;
    }
    for (var i = 0; i < keypoints.length; i++) {
        var keypoint = keypoints[i];
        var name = keypoint.name;
        //console.log("keypt.213:   INIT  ",i,"   = ", name);
        INFO.idx[name] = i;
    }
}



 /**
   * Draw the keypoints and skeleton on the video.
   * @param pose A pose with keypoints to render.
   */
function drawMovenetResult(canvas, ctx, poses, minPoseConfidence, color) {
    if ((poses === null) || (poses === undefined) || (poses[0] === undefined)) {
        return;
    }
    var pose = poses[0];

    if ((pose.keypoint !== undefined) && (Object.keys(INFO.idx).length === 0)) {
        collectKeypointIndex(pose.keypoints);
    }

    //if ((pose !== undefined) && (pose.keypoints != null) && (pose.score >= minPoseConfidence)) {
    if ((pose) && (pose.keypoints)) {
        //console.log("drawResults.180:    pose.score=",pose.score);

        if (INFO.show_facemask === true) {
            drawFaceMask(pose.keypoints, ctx);   // hide player face for privacy
        }

        if (INFO.show_skeleton === true) {
            //console.log("draw.225:  pose=", pose);
            drawMovenetKeypoints(ctx, pose.keypoints, color);
            drawMovenetSkeleton(ctx, pose.keypoints, color);
        }

        if ((INFO.show_3D === true) && (pose.keypoints3D)) {
            //if (scatterGLHasInitialized === false) {
            if (INFO.scatter_model_init === false) {
                init3DCanvas(canvas);
            }
            drawKeypoints3D(pose.keypoints3D, SCORE_THRESHOLD, ctx);
        }
    } else {
        console.log("drawResults.280:   SKIP POST DRAW   pose.score=",pose);
    }
}

  /**
   * Draw the keypoints on the video.
   * @param keypoints A list of keypoints.
   */
  function drawMovenetKeypoints(ctx, keypoints, color) {
    //const keypointInd = poseDetection.util.getKeypointIndexBySide(poseDetection.SupportedModels.MoveNet);
    const keypointInd = poseDetection.util.getKeypointIndexBySide(POSE_MODEL);
    //ctx.fillStyle = "rgba(200,200,200,0.4)";
    //ctx.strokeStyle = "rgba(200,200,200,0.4)";
    ctx.fillStyle = color;
    ctx.strokeStyle = color;
    ctx.lineWidth = DEFAULT_LINE_WIDTH;
    //console.log("draw.244:  ------- keypointInd=", keypointInd);

    for (const i of keypointInd.middle) {
      drawMovenetKeypoint(ctx, keypoints[i]);
    }

    ctx.fillStyle = "rgba(0,100,0,0.4)";
    for (const i of keypointInd.left) {
      drawMovenetKeypoint(ctx, keypoints[i]);
    }

    ctx.fillStyle = "rgba(100,100,0,0.4)";
    for (const i of keypointInd.right) {
      drawMovenetKeypoint(ctx, keypoints[i]);
    }
  }




  function drawMovenetKeypoint(ctx, keypoint) {

    if ((keypoint === undefined) || (keypoint === null)) {
        return;
    }
    //console.log("draw.261:  valid keypoint=", keypoint);

    // If score is null, just show the keypoint.
    //const score = (keypoint.score != null) ? keypoint.score : 1;
    const score = (keypoint.score != undefined) ? keypoint.score : 1;
    //const scoreThreshold = params.STATE.modelConfig.scoreThreshold || 0;
    const scoreThreshold = SCORE_THRESHOLD || 0;

    if (score >= scoreThreshold) {
      const circle = new Path2D();
      circle.arc(keypoint.x, keypoint.y, DEFAULT_RADIUS, 0, 2 * Math.PI);
      ctx.fill(circle);
      ctx.stroke(circle);
    }
  }



  /**
   * Draw the skeleton of a body on the video.
   * @param keypoints A list of keypoints.
   */
  function drawMovenetSkeleton(ctx, keypoints, color) {
    //ctx.fillStyle = "rgba(200,200,200,0.4)";
    //ctx.strokeStyle = "rgba(200,200,200,0.4)";
    //ctx.fillStyle = "rgba(255,0,0,1)";
    //ctx.strokeStyle = "rgba(255,0,0,1)";
    ctx.fillStyle = color;
    ctx.strokeStyle = color;
    ctx.lineWidth = DEFAULT_LINE_WIDTH;

    poseDetection.util
        //.getAdjacentPairs(params.STATE.model)
        .getAdjacentPairs(POSE_MODEL)
        .forEach(([ i, j ]) => { 
            const kp1 = keypoints[i];
            const kp2 = keypoints[j];
            if((kp1 === undefined) || (kp2 === undefined)) {
                return;
            }
            // If score is null, just show the keypoint.
            const score1 = kp1.score != null ? kp1.score : 1;
            const score2 = kp2.score != null ? kp2.score : 1;
            //const scoreThreshold = params.STATE.modelConfig.scoreThreshold || 0;
            const scoreThreshold = SCORE_THRESHOLD || 0;

            if (score1 >= scoreThreshold && score2 >= scoreThreshold) {
                ctx.beginPath();
                ctx.moveTo(kp1.x, kp1.y);
                ctx.lineTo(kp2.x, kp2.y);
                ctx.stroke();
            }
        });
  }


  
// WORKING 3D CODE BELOW
//
var scatterGL;
//var scatterGLHasInitialized = false;

function init3DCanvas(canvas0) {
    //var canvas = document.querySelector('#3d-gl-container');
    var canvas = document.getElementById('3d-gl-container');
    scatterGL = new scatter.ScatterGL(canvas, {
        'rotateOnStart': true,
        'selectEnabled': false,
        'styles': {polyline: {defaultOpacity: 1, deselectedOpacity: 1}}
    });
    //scatterGLHasInitialized = false;
    INFO.scatter_model_init = false;
}


const ANCHOR_POINTS = [[0, 0, 0], [0, 1, 0], [-1, 0, 0], [-1, -1, 0]];      // for 3D plotting
function drawKeypoints3D(keypoints, scoreThreshold, ctx) {
    //const scoreThreshold = scoreThreshold || 0;
    const pointsData =
        keypoints.map(keypoint => ([-keypoint.x, -keypoint.y, -keypoint.z]));

    const dataset =
        new scatter.ScatterGL.Dataset([...pointsData, ...ANCHOR_POINTS]);

    const keypointInd =
        poseDetection.util.getKeypointIndexBySide(POSE_MODEL);

    //console.log("3D.400:                     keypoints=",keypoints, "  dataset=",dataset, "  keypointInd=",keypointInd);

    scatterGL.setPointColorer((i) => {
      if (keypoints[i] == null || keypoints[i].score < scoreThreshold) {
        // hide anchor points and low-confident points.
        return '#ffffff';
      }
      if (i === 0) {
        return '#ff0000' // Red 
      }
      if (keypointInd.left.indexOf(i) > -1) {
        return '#00ff00' // Green 
      }
      if (keypointInd.right.indexOf(i) > -1) {
        return '#ffa500' // Orange
      }
    });

    //if (!scatterGLHasInitialized) {
    if (INFO.scatter_model_init === false) {
      scatterGL.render(dataset);
    } else {
      scatterGL.updateDataset(dataset);
    }
    const connections = poseDetection.util.getAdjacentPairs(POSE_MODEL);
    const sequences = connections.map(pair => ({indices: pair}));
    scatterGL.setSequences(sequences);
    //scatterGLHasInitialized = true;
    INFO.scatter_model_init = true;
}
//
///////////////////////////// MOVE ABOVE TO POSE-DRAW?  ///////////////////////////////////////////////////






// load from /public into canvas
export async function loadStaticImage(imagePath) {
    var path, isImage, promise;
    var dbits = imagePath.split("/");
    var bits = imagePath.split("_");
    var tbits = imagePath.split(".");
    var dir = bits[0];

    timeDelta();    // reset the clock to now
    if (dbits.length > 1) {
        path = `${imagePath}`
    } else {
        path = `samples/${bits[0]}/${imagePath}`
    }
    switch(tbits[1].toLowerCase()) {
        case "jpg":
        case "png":
            isImage = true;
            break;
        case "mov":
        case "mp4":
        case "webp":
        case "webm":
            isImage = false;
            break;
        default:
            console.log("loadStaticImage.227:  UNKNONWN FILE FORMAT!  ", tbits[1]);
            return;
    }

    if(true) {
        const nimage = new Image();
        promise = new Promise((resolve, reject) => {

            var canvas = document.getElementById(INFO.analysis_canvas);
            //const canvas = document.getElementById("vcanvas");
            canvas.style.visibility = "hidden";
            canvas.style.display = "none";


            nimage.src = `assets/images/${path}`
            nimage.crossOrigin = '';
            console.log("loadStaticImage.114: READING IMAGE...  ", nimage.src)
            nimage.onload = () => {
                resolve(nimage);
                console.log("loadStaticImage.116: SUCCESS  ", nimage)
                return nimage;
            };
        });
    } 
    return promise;
}


let image = null;
let predictedPoses = null;  // for posenet
let boxes = null;           // for yolo
let mprediction = null;     // for mobilenet

/**
 * Draw the results from the multi-pose estimation on to a canvas
 */
function drawMultiplePosesResults(canvas, image, lineWidth) {
    //const canvas = multiPersonCanvas();
    drawResults(canvas, image,
            predictedPoses, guiState.multiPoseDetection.minPartConfidence,
            guiState.multiPoseDetection.minPoseConfidence, lineWidth);
}

function setStatusText(text) {
    const resultElement = document.getElementById('status');
    resultElement.innerText = text;
}

/**
 * Purges variables and frees up GPU memory using dispose() method
 */
function disposePoses() {
    if (predictedPoses) {
        predictedPoses = null;
    }
    if (boxes) {
        boxes = null;
    }
    if (mprediction) {
        mprediction = null;
    }
}

	// MOVE THIS INTO UTIL
export function readImageListFile (evt) {
    var files = evt.target.files;
    var file = files[0];           
    if(file == undefined)
        return;

    var path = file.name;
    var prefixf = path.split("/")[2]
    var prefix = path.split(".")[0]

    INFO.file_list = file.name;
    var reader = new FileReader();
    reader.onload = function(event) {
      var imgs=event.target.result
      images=imgs.split("\n");

      gui.add(guiState, "file_list", images)
            .onChange(() => estimatePoseLoop(true, guiState.net, guiState.yolo, guiState.mobile));

      for (var i in gui.__controllers) {
          gui.__controllers[i].updateDisplay();
      }
    }

    console.log("reading index from: ",path);
    reader.readAsText(file)
    //imageBucket = 'assets/images/bo-wk3-prog/';
  }
  

/**
 * reads the source file, if video, setup the time and keep calling estimate
 * calculates poses based on the model outputs
 **/
async function estimatePoseLoop(has_file, net, yolov3, mobile) {
    var tbits = guiState.file_list.split(".");
    var is_video;

    if(guiState.model == null) {
        guiState.net = net;
        guiState.yolo = yolov3;
        guiState.mobile = mobile;

        INFO.pose_model = guiState.net;
        INFO.ball_model = guiState.yolo;
    }
    if(tbits < 2) {
        return;     // no extension, bad file name
    }

    // Creates a tensor from an image and estimate poses
    if(has_file == true) {

        guiState.file_name = tbits[0].split("/")[1];
        switch(tbits[1].toLowerCase()) {
            case "jpg":
            case "jpeg":
            case "png":
                is_video = false;
                break;
            case "mp4":
            case "mov":
            case "webp":
            case "webm":
                is_video = true;
                break;
        }

        INFO.file_name = guiState.file_list;   // this is actually the file name
        if(is_video) {
            const path = `assets/images/${guiState.file_list}`
            setupVideoFile(path, guiState.play_speed);   // willl do auto read from video
            //TFMem("estimatePoseLoop.396");
            return;
        } else {
            //console.log("IMAGE LOADING......... ", guiState.file_list);
            image = await loadStaticImage(guiState.file_list);
            //TFMem("estimatePoseLoop.391");
            await analyzeImage(image, null);
            //TFMem("estimatePoseLoop.393");
        }
    }
    //TFMem("estimatePoseLoop.END");
}

/*
 * move to yolo later
 *
 */
async function kerasPostProcess(num_class, classNames, outputs) {
    var t1d, t26, t13, nout=[];
    var filters = (num_class + 5) * 3;    // outputs = [1, 2535, 7] =  17745
    var out_len = (13 * 13 * 3) + (26 * 26 * 3);    // 2535

    const iouThreshold = IOU_THRESHOLD;
    const scoreThreshold = SCORE_THRESHOLD;
    const maxBoxes = 10;
    const numAnchors = 3;   // KLUDGE: HARDCODE!
    const numClasses = 2;   // KLUDGE: HARDCODE!
    //TFMem("kerasPostProcess.START");

    // yoloBoxesAndScores(): split up the outputs
    // format is x0, x1, y0, y1 ====> NOT w, y, w, h!!
    const [xy0, xy1, con, probs] =  tf.tidy(() => {return tf.split(outputs, [2, 2, 1, numClasses], 2)});  // splits 2, 2, 1, 3 along axis 2

    // boxes = yoloCorrectBoxes(xy, wh, [YOLO_INPUT_SIZE, YOLO_INPUT_SIZE]);     // scale back to orig shape
    //
    let boxXy0 = tf.tidy(() => {return tf.concat(tf.split(xy0, 2, 2).reverse(), 2)});      // upper left most corner
    let boxXy1 = tf.tidy(() => {return tf.concat(tf.split(xy1, 2, 2).reverse(), 2)});
    //TFMem("kerasPostProcess.436");
    //console.log("tt-keras.380:                  SPLIT BOXES ", timeDelta());

    var boxes = tf.tidy(() => {return tf.concat([
                    ...tf.split(boxXy0, 2, 2),
                    ...tf.split(boxXy1, 2, 2)
                ], 2)});
    //TFMem("kerasPostProcess.443");

    //;
    // yoloBoxesAndScores
    //
    boxes = tf.tidy(() => {return boxes.reshape([-1, 4])})     // no help
    let boxScores = tf.tidy(() => {return tf.mul(con, tf.sigmoid(probs))});
    var _boxScores = tf.tidy(() => {return tf.reshape(boxScores, [-1, numClasses])})   // no help
    //TFMem("kerasPostProcess.452");
    //console.log("tt-keras.395:                  GOT BOXES & SCORES ", timeDelta());


    //
    // rest of yoloEval(), make boxes and boxScores
    //
    var aboxes = []
    var aboxScores = []
    tf.tidy(() => {aboxes.push(boxes)})
    tf.tidy(() => {aboxScores.push(_boxScores)})

    boxes = tf.concat(aboxes);
    boxScores = tf.concat(aboxScores);
    //TFMem("kerasPostProcess.470");

    //
    // dedupe boxes - This takes a long time, ~50 ms, do NOT "await"!
    //
    const _classes = tf.tidy(() => {return tf.argMax(_boxScores, -1)})
    _boxScores = tf.tidy(() => {return tf.max(boxScores, -1)})     // convert to 1D?
    const nmsIndex = await tf.image.nonMaxSuppressionAsync(     // MUST HAVE AWAIT!!!
    //const nmsIndex = tf.image.nonMaxSuppressionAsync(       // this does not block, but do not work!
        boxes,      // (2535, 4)
        _boxScores,
        maxBoxes,
        iouThreshold,
        scoreThreshold
    );
    //TFMem("kerasPostProcess.490");
    //console.log("tt-keras.424:                  DEDUPE BOXES ", timeDelta());

    // TAIL of yoloPostProcess()
    let boxes_ = [];
    let scores_ = [];
    let classes_ = [];
    var classBoxes, classBoxScores;
    if (nmsIndex.size) {
        classBoxes =  tf.tidy(() => {return tf.gather(boxes, nmsIndex)});       // no help
        classBoxScores =  tf.tidy(() => {return tf.gather(_boxScores, nmsIndex)});  // no help

        //console.log("yoloPostProcess.43: classBoxScores=", classBoxScores, "  nmsIndex=", nmsIndex);
        tf.tidy(() => {
            classBoxes.split(nmsIndex.size).map(box => {
                boxes_.push(box.dataSync());
            });
        })

        tf.tidy(() => {
            classBoxScores.dataSync().map(score => {
                scores_.push(score);
            });
        })

        classes_ = tf.tidy(() => {return _classes.gather(nmsIndex).dataSync()});
    }
    //console.log("549:  boxes_=",boxes_)
    //console.log("tt-keras.451:                  CLEAN UP BOXES ", timeDelta());

    let imageShape = [YOLO_INPUT_SIZE, YOLO_INPUT_SIZE];     // scale back to orig shape
    var out_boxes =  tf.tidy(() => {
            return boxes_.map((box, i) => {
                const top = Math.max(0, box[0]);
                const left = Math.max(0, box[1]);
                const bottom = Math.min(imageShape[0], box[2]);
                const right = Math.min(imageShape[1], box[3]);
                const height = bottom - top;
                const width = right - left;
                return {
                    top,
                    left,
                    bottom,
                    right,
                    height,
                    width,
                    score: scores_[i],
                    class: classNames[classes_[i]]
                }
            })
        });
    //console.log("tt-keras.474:                  FINAL MAPPING ", timeDelta());

    //TFMem("kerasPostProcess.b4_free");
    tf.dispose(outputs);
    tf.dispose(xy0);
    tf.dispose(xy1);
    tf.dispose(con);
    tf.dispose(probs);
    tf.dispose(boxXy0);
    tf.dispose(boxXy1);
    tf.dispose(aboxes);
    tf.dispose(aboxScores);

    tf.dispose(boxes);
    tf.dispose(boxScores);
    tf.dispose(_classes);
    tf.dispose(_boxScores);
    tf.dispose(nmsIndex);
    tf.dispose(boxes_);
    tf.dispose(scores_);
    tf.dispose(classes_);
    tf.dispose(classBoxes);
    tf.dispose(classBoxScores);

    //console.log("kera.449: post process ", timeDelta());
    //TFMem("kerasPostProcess.END");
    return out_boxes;
}




//
// MAIN: AI analysis - this is used, not renderResult() in video.js
//      - feeds image into posenet the posenet model, and
//      - calculates poses based on the model outputs
//      - NOTE: HOW DOES THIS FIT WITH renderResult() in video?
// XXCD
// ref: https://github.com/tensorflow/tfjs-models/tree/master/pose-detection/demos
//
var aiconsole_log = (false) ?  console.log : () => {};   // true will enable console.log
export async function analyzeImage(src, t0) {
    var mprediction = null, imageTensor = null, input = null;
    var boxes = null, outputs = null, input =null, poses = null;
    var img_text = "none", pcanvas = null;
    var image_width, image_height;
    var yolo_img_ratio, yolo_draw_width, yolo_draw_height;
    var yolo_width_padding, yolo_height_padding;
    var pose_img_ratio, pose_draw_width, pose_draw_height;
    var pose_width_padding, pose_height_padding;
    var is_video = false, is_canvas = false;
	var hidx = HISTORY.length - 1;
    INFO.current_hidx = hidx;

    aiconsole_log("tt-out.517: vvvvvvvvvvvvvvvvvvvvvvv ANALYZE IMAGE START...  hidx=",hidx," ", timeDelta(), " canvas=",INFO.analysis_canvas, " vvvvvvvvvvvvvvvvvvvvvvvv");
    tf.disposeVariables();
    if((guiState.net == null) || (src == undefined) || (src == null)) {
        console.error("tt-out.790:        ! ! ! ! ! !  ERROR:  CAN'T ANALYZE IMAGE   net=", guiState.net, " src=", src);
        return;      // not ready yet
    }

    img_text = INFO.file_name;
    switch (src.constructor.name) {
        case 'HTMLVideoElement':
            //console.log("drawResults.183: ***** DETECTED VIDEO=", src);
            image_width = src.videoWidth;
            image_height = src.videoHeight;
            is_video = true;
            break;
        case "HTMLImageElement":
        case "SVGImageElement":
        case "ImageBitmap":
            //console.log("analyzeImage.559: ***** DETECTED IMAGE=", src);
            image_width = src.width;
            image_height = src.height;
            break;
        case "HTMLCanvasElement":
            //console.log("drawResults.651: ***** DETECTED CANVAS=", src);
            image_width = src.width;
            image_height = src.height;
            is_canvas = true;
            break;
        default:
            console.log("ERROR: Unsupported format...", src.constructor.name);
            return;
    }
    //TFMem("runModel.691");
    INFO.image_width = image_width;
    INFO.image_height = image_height;

    const net = guiState.net;
    const yolov3 = guiState.yolo;
    const mobile = guiState.mobile;
    disposePoses();   // Purge prevoius variables and free up GPU memory
    //console.log("est.632: Frame START ", timeDelta());

    // use ratio of the long dimension, pad along the short
    if(is_video == true) {
        yolo_img_ratio = (src.videoWidth > src.videoHeight) ? 
            YOLO_INPUT_SIZE/src.videoWidth : YOLO_INPUT_SIZE/src.videoHeight;
        yolo_draw_width = Math.floor(src.videoWidth * yolo_img_ratio);
        yolo_draw_height = Math.floor(src.videoHeight * yolo_img_ratio);

        // play video file
        //
        if ((INFO.use_movenet === true) || (INFO.use_blazepose === true)) {
            pose_img_ratio = src.videoWidth / src.videoHeight;   // 0.6?  should be 1.33
            pose_draw_width = src.videoWidth;       // 192 px
            pose_draw_height = src.videoHeight;     // 144 px
            //console.log("685:  VIDEO.MOVENET  movenet=",INFO.use_movenet,"  blaze=",INFO.use_blazepose, " pose_w_ratio=", (pose_img_ratio)," draw_w=", (pose_draw_width), " draw_h=", (pose_draw_height))
        } else {
            // for old posenet
            pose_img_ratio = (src.videoWidth > src.videoHeight) ? 
                POSE_INPUT_SIZE/src.videoWidth : POSE_INPUT_SIZE/src.videoHeight;
            pose_draw_width = Math.floor(src.videoWidth * pose_img_ratio);
            pose_draw_height = Math.floor(src.videoHeight * pose_img_ratio);
        }
    } else {
        yolo_img_ratio = (src.width > src.height) ? 
            YOLO_INPUT_SIZE/src.width : YOLO_INPUT_SIZE/src.height;
        yolo_draw_width = Math.floor(src.width * yolo_img_ratio);
        yolo_draw_height = Math.floor(src.height * yolo_img_ratio);

        // webcam dump to canvas
        //
        if ((INFO.use_movenet === true) || (INFO.use_blazepose === true)) {
            pose_img_ratio = Math.floor(src.width / src.height * 1000)/ 1000;   // 0.6?  should be 1.33
            pose_draw_width = src.width;       // 192 px ==> 320 px
            pose_draw_height = src.height;     // 144 px ==> 240 px
            //console.log("705:  WEBCAM.MOVENET pose_w_ratio=", (pose_img_ratio)," draw_w=", (pose_draw_width), " draw_h=", (pose_draw_height))
        } else {
            // for old posenet
            pose_img_ratio = (src.width > src.height) ? 
                POSE_INPUT_SIZE/src.width : POSE_INPUT_SIZE/src.height;
            pose_draw_width = Math.floor(src.width * pose_img_ratio);
            pose_draw_height = Math.floor(src.height * pose_img_ratio);
        }
    }

    INFO.yolo_img_ratio = yolo_img_ratio;
    yolo_width_padding = YOLO_INPUT_SIZE - yolo_draw_width;
    yolo_height_padding = YOLO_INPUT_SIZE - yolo_draw_height;

    INFO.pose_img_ratio = pose_img_ratio;
    pose_width_padding = POSE_INPUT_SIZE - pose_draw_width;
    pose_height_padding = POSE_INPUT_SIZE - pose_draw_height;

    image = src;
    //console.log("590:  FEED AI IMAGE pose_w_ratio=", (pose_img_ratio)," draw_w=", (pose_draw_width), " draw_h=", (pose_draw_height))
    //TFMem("runModel.718");
    //return;

    // AI pose estimation
    //
    //console.log("draw.888:     ............. use_blazepose=",INFO.use_blazepose, "  use_media_pipe=",INFO.use_media_pipe);
    if(guiState.model.enabled == true) {
        //console.log("est.671: Start pose estimate  time=", timeDelta());
        if (INFO.use_blazepose === true) {

            // BlazePose: Latest Fastest 2021 model using media_pipe
            //
            if (INFO.use_media_pipe === true) {

                // src: https://google.github.io/mediapipe/solutions/pose#resources
                const estimationConfig = {
                    maxPoses: 1,
                    modelComplexity: 1,
                    smoothLandmarks: false,         // true,
                    minDetectionConfidence: 0.3,
                    minTrackingConfidence: 0.3,
                    enableSmoothing: true, 
                    enableSegmentation: false,      // true;
                    smoothSegmentation: false,      // true,
                };
                poses = await net.estimatePoses(image, estimationConfig)    // mediapipe
                            .then((poses) => {
                                if (!poses[0]) { return [] };
                                return poses;
                            })
                            .catch((err) => {
                                console.error("draw.blaze-mediapipe.811:     ..................POSES ERROR: ", err);
                            });
                //console.log("draw.blaze-mediapipe.905:     ............ MEDIAPIPE poses=",poses);

            } else {
                // Note: blazepose output: poses[ keypoints[ {name, score, x, y, z} ] ]
                // MAIN.XXCD: Feed image to AI
                //const estimationConfig = {maxPoses: 1};      //true};
                //const estimationConfig = {flipHorizontal: true};
                const estimationConfig = {      // tfjs + webgl
                    maxPoses: 1, 
                    flipHorizontal: true,
                    enableSmoothing: true,
                    enableSegmentation: false,      // MUST DISABLE
                };
                const timestamp = Date.now();   //const timestamp = performance.now();
                poses = await net.estimatePoses(image, estimationConfig, timestamp)
                            .then((poses) => {
                                /*
                                var pose = poses[0];
                                if (pose === undefined)  return []; 
                                //console.log(".....................BLZ-TFJS pose.keypoints3D=", pose.keypoints3D); //this.drawKeypoints3D(pose.keypoints3D);
                                for (var i = 0; i < pose.keypoints.length; i++) 
                                    // KLUDGE: APPLY BIAS OFFSET, NEED TO FIGURE THE ROOT CAUSE, IMAGE SIZE ISSUE?
                                    var k = pose.keypoints[i];
                                    k.x = k.x - 12;     // MEGA-KLUDGE!
                                    k.y = k.y - 12;     // MEGA-KLUDGE!
                                /**/

                                /* DEBUG: find out the keypoint limits
                                //
                                var pose_debug = false;
                                if(pose_debug && poses[0]) 
                                    var max_x = 0, max_y = 0, min_x = 99999, min_y = 999999;
                                    var pose = poses[0];
                                    for (var i = 0; i < pose.keypoints.length; i++) 
                                        var k = pose.keypoints[i];
                                        if(k.score > 0.8) 
                                            if(k.x < min_x)  min_x = Math.floor(k.x); 
                                            if(k.y < min_y)  min_y = Math.floor(k.y); 
                                            if(k.x > max_x)  max_x = Math.floor(k.x); 
                                            if(k.y > max_y)  max_y = Math.floor(k.y); 
                                    console.log("draw.blaze.770:           . . . . GOT TFJS POSES:  max_x=", max_x, " max_y=",max_y, " min_x=",min_x, " min_y=",min_y, " canvas=",INFO.analysis_canvas);
                                /**/
                                if (!poses[0]) { return [] };
                                return poses
                            })
                            .catch((err) => {
                                console.error("draw.blaze.775:     ..................POSES ERROR: ", err);
                            });
                //console.log("draw.blaze-tfjs.991:     .............TFJS poses=",poses);

            }
        }
        
       /* 
        else if (INFO.use_movenet === true) {

            poses = await net.estimatePoses(image)     // let the lib pad it
                            .then((poses) => {
                                return poses;
                            })
                            .catch((err) => {
                                console.log("draw.blaze.775:     ..................POSES ERROR: ", err);
                            });
            console.log("draw.movenet.1004:     .............MOVENET  poses=",poses);

        } else {

            // old posenet,  setup image before calling (needed?)
            input = tf.tidy(() => {return tf.browser.fromPixels(image)
                    .resizeBilinear([pose_draw_height, pose_draw_width])
                    .pad([[0, pose_height_padding], [0, pose_width_padding], [0, 0]], 128)})
            //console.log("627:  pose input=", input.shape);      // [416, 416, 3]
            //TFMem("runModel.740");
            console.log("tt-out.597:                POSE TENSOR PREPED ", timeDelta());

            poses = await net.estimatePoses(input, {
                flipHorizontal: false,
                decodingMethod: 'single-person',  // 'multi-person',
                maxDetections: guiState.multiPoseDetection.maxDetections,
                scoreThreshold: guiState.model.threshold,       // guiState.multiPoseDetection.minPartConfidence,
                nmsRadius: guiState.multiPoseDetection.nmsRadius
            });
            tf.dispose(input);

            console.log("draw.other.1023:     .............OTHER  poses=",poses);
        }
        */


    }


    aiconsole_log("tt-out.617:        +++++++ POSE IMAGE ANALYZED... hidx=",hidx,"   now=",Date.now()%100000/1000, " ",(poses.length>0) ? "**************** HAS POSE "+timeDelta()+" ***************" : "     NO POSE "+timeDelta());
    //TFMem("runModel.749");

    //console.log("est_pose.1028:     .............got poses=",poses);
    //return poses;

    //
    // detect soccer ball via yolo
    // src: https://github.com/shaqian/tfjs-yolo-demo/blob/master/docs/src/index.js
    //
    if (false && (guiState.yolomodel.enabled == true) && (INFO.skip_ball_detect == false)) {
        //console.log("673: w_pad=",width_padding, "  h_pad=", height_padding);
        imageTensor = tf.tidy(() => {
            return tf.browser.fromPixels(image)
                //.resizeNearestNeighbor([draw_height, draw_width])
                .resizeBilinear([yolo_draw_height, yolo_draw_width])  // good
                .pad([[0, yolo_height_padding], [0, yolo_width_padding], [0, 0]], 128)   // pad 128 to end
                .toFloat()          // MATCH
                .expandDims()       // MATCH
                //.div(tf.scalar(255));       // BAD!!!  THIS IS THE PROBLEM!!!!
        })
        //console.log("680:  imageTensor=", imageTensor.shape);   // [1, 416, 416, 3]
        console.log("tt-out.628:                  BALL TENSOR PREPED ", timeDelta());

        outputs = await yolov3.predict(imageTensor); 
        tf.dispose(imageTensor);
        console.log("tt-out.631:                  BALL PREDICT DONE ", timeDelta());
        //console.log("kera.737: GOT yolov3 RESULTS ",  timeDelta());
        //TFMem("runModel.811");

        my_classes = soccer_classes;
        if(SOCCER_MODEL) {
            // For Keras .pb Frozon Model ONLY
            // Convert (1, 2535, 7) => [(1, 13, 13, 21), (1, 26, 26, 21)]
            // Output is Detected box, normalized
            boxes = await kerasPostProcess(my_classes.length, my_classes, outputs)
            //console.log("811:   KERAS OUTPUT BOXES=", boxes);
        } else {
            boxes = await yoloPostProcess(
                "v3tiny",
                outputs,
                v3_tiny_anchors,     // anchors = 
                my_classes.length, // numClasses = 
                my_classes,        // classNames = 
                [YOLO_INPUT_SIZE, YOLO_INPUT_SIZE],
                MAX_BOXES,           // maxBoxes = 
                guiState.yolomodel.threshold,     // scoreThreshold = 
                IOU_THRESHOLD        // iouThreshold = 
            );
        }
        tf.dispose(outputs);
    }
    else if(false && guiState.mobilenet.enabled == true) { // detect soccer ball using mobilenet
        mprediction = await mobile.detect(image, 20, guiState.mobilenet.threshold);
    }

    //console.log("tt-out.657:         -------- BALL IMAGE ANALYZED...", timeDelta(), " -------");
    //TFMem("runModel.845");
    var success = (poses.length > 0) ? true : false;

    //const t1 = performance.now();
    //console.log("**** Model prediction ENDED, took " + Math.floor(t1 - t0) + " msec");
    //console.log("since last pose: ",(t1 - last_timestamp));
    if(true && (guiState.model.enabled == true)) {
        last_timestamp = t0;

        //console.log("estimatePoseLoop.1051: Result... poses=",poses, "canvas=", INFO.analysis_canvas);
        predictedPoses = poses;
        if ((poses !== undefined) && (poses.length > 0)) {
            if ((poses[0].keypoints !== undefined) && (Object.keys(INFO.idx).length === 0)) {
                collectKeypointIndex(poses[0].keypoints);
            }
            //console.log("store_pose.908:  OUTPUT STAGE keypoints=",poses[0].keypoints.length, " keypoints3D=",poses[0].keypoints3D.length, " INFO.idx=", Object.keys(INFO.idx).length);

            if ((INFO.use_movenet === true) || (INFO.use_blazepose === true)) {
                predictedPoses.forEach((pose) => {
                    //console.log("pose.662:  pose.keypoints=",pose.keypoints);
                })
            } else {
                // convert position back to orignal aspect ratio
                predictedPoses.forEach((pose) => {
                    //console.log("pose.662:  pose.keypoints=",pose.keypoints);
                    pose.keypoints.forEach((keypoint) => {
                        keypoint.x = keypoint.x / pose_img_ratio;
                        keypoint.y = keypoint.y / pose_img_ratio;
                    })
                })
            }

            //console.log("store_pose.883:  poses=",poses, " ht=",image_height, " p.len=",poses.length, " p_valid=",(poses == null));
            storePoseData(t0, poses[0], image_height);
        } 

        var lineWidth = (image_width * image_height)/(230 * 1000) + 3;      // KLUDGE: HARD CODE RATIO, SHOULD USE SCALE
        var canvas = document.getElementById(INFO.analysis_canvas);
        drawResults(canvas, image,
            predictedPoses, guiState.multiPoseDetection.minPartConfidence,
            guiState.multiPoseDetection.minPoseConfidence, lineWidth);


        tf.dispose(poses);
        tf.dispose(predictedPoses);
    }
    aiconsole_log("tt-out.698:                   SKELETON RENDER COMPLETED", timeDelta());
    //TFMem("runModel.886");

    //TIMES.inference_completed = Date.now();   //const t2 = performance.now();    
    //return success;

    if(guiState.mobilenet.enabled == true) {
        //console.log('****** Mobilenet Predictions1: ', mprediction);
        var canvas1 = document.getElementById(INFO.analysis_canvas);
        canvas1.style.display = "block";
        canvas1.width = parseInt(image_width);
        canvas1.height = parseInt(image_height);
        //renderImageToCanvas(image, [image_width, image_height], canvas1);
        var ctx1 = canvas1.getContext('2d');
        var font_size = (image_width + image_height)/90;
        //console.log("430:  image_width=", image_width, "  font_size=", font_size)
        ctx1.font = (image_width+image_height/90).toString()+"px arial";
        ctx1.fillStyle = "yellow";
        ctx1.fillText("MOBILENET: "+img_text.toUpperCase(), 0, image_height/100);
        ctx1.stroke();

        ctx1.font = font_size.toString()+"px arial";
        for(var b = 0; b < mprediction.length; b++) {
            var pred = mprediction[b];
            var box = pred.bbox;
            //if(pred.class !== "person") 
            if((pred.class == "soccer") || (pred.class == "cone")) {
                ctx1.fillStyle = 'rgba(255,255,0,0.5)';
                ctx1.font = (image_width + image_height/140).toString()+"px arial";
                ctx1.fillText(pred.class.toUpperCase(), box[0], box[1]);
                ctx1.rect(box[0], box[1]+2, box[2], box[3]);
                ctx1.strokeStyle = 'rgba(0,200,160,0.3)';
                ctx1.lineWidth = (pred.score * 12) + 1;
                ctx1.stroke();
                //console.log("M",b, ": ", Math.round(pred.score*100),"%  ",pred.class,
                //            "%  L=", Math.round(box[0])," T=", Math.round(box[1]), " W=", Math.round((box[2])), " H=", Math.round((box[3])));
            }
        }
        tf.dispose(mprediction);
    } 


    // final result processing
    //
    if ((guiState.yolomodel.enabled == true) && (INFO.skip_ball_detect == false)) {

        storeBallData(boxes, yolo_img_ratio, image_width, image_height);
        performFrameAnalysis();         // MAIN ANALYSIS ENTRY
        tf.dispose(boxes);
        aiconsole_log("tt-out.739:                       BALL DATA EXTRACTION COMPLETED", timeDelta());
    } else {

        performFrameAnalysis();         // MAIN ANALYSIS ENTRY
    }
    aiconsole_log("tt-out.747: ^^^^^^^^^^^^^^^^^ IMAGE ANALYSIS COMPLETED!", timeDelta(), "  ^^^^^^^^^^^^^^^^^^^");

    //TFMem("analyzeImage.END");
    if (success === true) {
        const t2 = Date.now();   //const t2 = performance.now();    
        TIMES.inference_completed = t2;
        var hidx9 = HISTORY.length - 1;
        //console.log("1199: **** Total inference COMPLETED   delta=", Math.floor(t2 - t0), "msec  hidx9=",hidx9," start=",parseInt(t0), " end=", parseInt(t2), " poses=",poses.length);
    }
    return success;

}   ////////////////////   end of analyzeImage()




/**
 * Reloads PoseNet, then loads an image, feeds it into posenet, and
 * calculates poses based on the model outputs
 */
async function reloadNetanalyzeImage(net) {
    if (guiState.net) {
        guiState.net.dispose();
    }
    /*
    toggleLoadingUI(true);
    guiState.net = await posenet.load({
        architecture: guiState.model.architecture,
        outputStride: guiState.model.outputStride,
        inputResolution: guiState.model.inputResolution,
        multiplier: guiState.model.multiplier,
        quantBytes: guiState.model.quantBytes,
    });
    toggleLoadingUI(false);
    estimatePoseLoop(true, guiState.net, guiState.yolo, guiState.mobile);
    */
}



// BELOW IS DEV CONSOLE CODE
//
export var guiState = {
    net: null,
    yolo: null,
    mobile: null,
    backend: "webgl",

    webcam: false,
    recording: false,
    stop_video: false,
    measure: INFO.perf_mode,
    save_log: INFO.logging_mode,
    batch: "none",

    output: INFO.analysis_canvas,
    defender: INFO.show_defender,       // display defender
    cones: INFO.show_cones,       // display defender
    calib_mark: INFO.show_calibration_mark,       // display defender
    play_speed: 1,       // video play speed


    yolomodel: {
        enabled: true,
        threshold: SCORE_THRESHOLD,
    },
    mobilenet: {
        enabled: false,
        threshold: SCORE_THRESHOLD,
    },
    model: {
        enabled: true,
        architecture: 'MobileNetV1',
        outputStride: defaultMobileNetStride,
        inputResolution: defaultMobileNetInputResolution,
        multiplier: defaultMobileNetMultiplier,     // bigger more accurate
        quantBytes: defaultQuantBytes,  // 4=90MB, 2=45MB, 1=22MB
        threshold: SCORE_THRESHOLD
    },

    videos: null,
    image: null,
    file_list: [],     // list of files
    file_name: null,
    directory: 'bo-wk3-prog',
    multiPoseDetection: {
        minPartConfidence: defaultPartConfidence,
        minPoseConfidence: defaultPoseConfidence,
        nmsRadius: 20.0,
        maxDetections: 15,
    },
    showKeypoints: true,
    showSkeleton: true,
    showBoundingBox: false,
};

async function setupGui(net, yolo, mobilen) {
    guiState.net = await net;
    guiState.yolo = await yolo;
    guiState.mobile = mobilen;
    console.log("setupGui.948: posenet=", net, " yolo=",yolo, " time=", timeDelta());
    INFO.pose_model = guiState.net;
    INFO.ball_model = guiState.yolo;

    const control_knobs = gui.addFolder('Flow Control');
    control_knobs.open();
    control_knobs.add(guiState, 'recording').onChange(on_status => {recordOutput(INFO.analysis_canvas, INFO.file_name, on_status)});
    control_knobs.add(guiState, 'webcam').onChange(on_status => {initWebcamAI(net, on_status, "even_webcam.1270")});
    control_knobs.add(guiState, 'stop_video').onChange(on_status => {stopVideo(on_status)});
    control_knobs.add(guiState, 'measure').onChange(out => {INFO.perf_mode = out});
    control_knobs.add(guiState, 'save_log').onChange(out => {INFO.logging_mode = out});
    control_knobs.add(guiState, 'batch', ['none', 'videos','images']).onChange(task => {batchAnalysis(task, images)});

    const display_knobs = gui.addFolder('Display');
    display_knobs.open();
    display_knobs.add(guiState, 'output', ['none', 'output','yolo']).onChange(out => {initVideoDisplay(out)});
    display_knobs.add(guiState, 'defender').onChange(out => {INFO.show_defender = out});
    display_knobs.add(guiState, 'cones').onChange(out => {INFO.show_cones = out});
    display_knobs.add(guiState, 'calib_mark').onChange(out => {INFO.show_calibration_mark = out});
    display_knobs.add(guiState, 'play_speed', 0.1, 3.0).onChange(drawMultiplePosesResults);

    gui.add(guiState, 'backend', ['wasm', 'webgl', 'cpu', 'webgpu']).onChange(async backend => {
        console.log("before: tf.backend=",tf.getBackend());
        await tf.setBackend(backend);
        console.log("after: tf.backend=",tf.getBackend());
    });

    let architectureController = null;
    guiState[tryResNetButtonName] = function() {
        architectureController.setValue('ResNet50')
    };
    gui.add(guiState, tryResNetButtonName).name(tryResNetButtonText);
    updateTryResNetButtonDatGuiCss();

    const yolo_model = gui.addFolder('Yolo');
    //yolo_model.open();
    yolo_model.add(guiState.yolomodel, 'enabled').onChange(drawMultiplePosesResults);
    yolo_model.add(guiState.yolomodel, 'threshold', 0.0, 1.0)
              .onChange(drawMultiplePosesResults);
    yolo_model.close();

    const mobilenet_model = gui.addFolder('MobileNet');
    //mobilenet_model.open();
    mobilenet_model.add(guiState.mobilenet, 'enabled').onChange(drawMultiplePosesResults);
    mobilenet_model.add(guiState.mobilenet, 'threshold', 0.0, 1.0)
              .onChange(drawMultiplePosesResults);


    // Input resolution:    Internally, this parameter affects the height and width
    // of the layers in the neural network. The higher the value of the input
    // resolution the better the accuracy but slower the speed.
    const model = gui.addFolder('Posenet');
    //model.open();
    model.add(guiState.model, 'enabled').onChange(drawMultiplePosesResults);
    let inputResolutionController = null;
    function updateGuiInputResolution(inputResolutionArray) {
        if (inputResolutionController) {
            inputResolutionController.remove();
        }
        inputResolutionController =
                model.add(guiState.model, 'inputResolution', inputResolutionArray);
        inputResolutionController.onChange(async function(inputResolution) {
            guiState.model.inputResolution = +inputResolution;
            reloadNetanalyzeImage(guiState.net);
        });
    }
    // Output stride:    Internally, this parameter affects the height and width of
    // the layers in the neural network. The lower the value of the output stride
    // the higher the accuracy but slower the speed, the higher the value the
    // faster the speed but lower the accuracy.
    let outputStrideController = null;
    function updateGuiOutputStride(outputStrideArray) {
        if (outputStrideController) {
            outputStrideController.remove();
        }
        outputStrideController =
                model.add(guiState.model, 'outputStride', outputStrideArray);
        outputStrideController.onChange((outputStride) => {
            guiState.model.outputStride = +outputStride;
            reloadNetanalyzeImage(guiState.net);
        });
    }

    // Multiplier: this parameter affects the number of feature map channels in
    // the MobileNet. The higher the value, the higher the accuracy but slower the
    // speed, the lower the value the faster the speed but lower the accuracy.
    let multiplierController = null;
    function updateGuiMultiplier(multiplierArray) {
        if (multiplierController) {
            multiplierController.remove();
        }
        multiplierController =
                model.add(guiState.model, 'multiplier', multiplierArray);
        multiplierController.onChange((multiplier) => {
            guiState.model.multiplier = +multiplier;
            reloadNetanalyzeImage(guiState.net);
        });
    }

    // QuantBytes: this parameter affects weight quantization in the ResNet50
    // model. The available options are 1 byte, 2 bytes, and 4 bytes. The higher
    // the value, the larger the model size and thus the longer the loading time,
    // the lower the value, the shorter the loading time but lower the accuracy.
    let quantBytesController = null;
    function updateGuiQuantBytes(quantBytesArray) {
        if (quantBytesController) {
            quantBytesController.remove();
        }
        quantBytesController =
                model.add(guiState.model, 'quantBytes', quantBytesArray);
        quantBytesController.onChange((quantBytes) => {
            guiState.model.quantBytes = +quantBytes;
            reloadNetanalyzeImage(guiState.net);
        });
    }
    model.add(guiState.model, 'threshold', 0.0, 1.0)
              .onChange(drawMultiplePosesResults);

    function updateGui() {
        updateGuiInputResolution([257, 353, 449, 513, 801]);
        if (guiState.model.architecture.includes('ResNet50')) {
            updateGuiOutputStride([32, 16]);
            updateGuiMultiplier([1.0]);
        } else {
            updateGuiOutputStride([8, 16]);
            updateGuiMultiplier([0.5, 0.75, 1.0]);
        }
        updateGuiQuantBytes([1, 2, 4])
    }

    // Architecture: there are a few PoseNet models varying in size and
    // accuracy. 1.01 is the largest, but will be the slowest. 0.50 is the
    // fastest, but least accurate.
    architectureController =
            model.add(guiState.model, 'architecture', ['MobileNetV1', 'ResNet50']);
            //model.add(guiState.model, 'architecture', ['MobileNetV2', 'MobileNetV1', 'ResNet50']);

    architectureController.onChange(async function(architecture) {
        if (architecture.includes('ResNet50')) {
            guiState.model.inputResolution = defaultResNetInputResolution;
            guiState.model.outputStride = defaultResNetStride;
            guiState.model.multiplier = defaultResNetMultiplier;
        } else {
            guiState.model.inputResolution = defaultMobileNetInputResolution;
            guiState.model.outputStride = defaultMobileNetStride;
            guiState.model.multiplier = defaultMobileNetMultiplier;
        }
        guiState.model.quantBytes = defaultQuantBytes;
        guiState.model.architecture = architecture;
        updateGui()
        reloadNetanalyzeImage(guiState.net);
    });

    updateGui();

    /*
    gui.add(guiState, 'directory', directory)
            .onChange(() => initDirectory(guiState.net));
    */

    gui.add(guiState, 'file_list', images)
            .onChange(() => estimatePoseLoop(true, guiState.net, guiState.yolo, guiState.mobile));

    // Pose confidence: the overall confidence in the estimation of a person's
    // pose (i.e. a person detected in a frame)
    // Min part confidence: the confidence that a particular estimated keypoint
    // position is accurate (i.e. the elbow's position)
    const multiPoseDetection = gui.addFolder('Multi Pose Estimation');
    //multiPoseDetection.open();
    multiPoseDetection
            .add(guiState.multiPoseDetection, 'minPartConfidence', 0.0, 1.0)
            .onChange(drawMultiplePosesResults);
    multiPoseDetection
            .add(guiState.multiPoseDetection, 'minPoseConfidence', 0.0, 1.0)
            .onChange(drawMultiplePosesResults);

    // nms Radius: controls the minimum distance between poses that are returned
    // defaults to 20, which is probably fine for most use cases
    multiPoseDetection.add(guiState.multiPoseDetection, 'nmsRadius', 0.0, 40.0)
            .onChange(() => estimatePoseLoop(true, guiState.net, guiState.yolo, guiState.mobile));
    multiPoseDetection.add(guiState.multiPoseDetection, 'maxDetections')
            .min(1)
            .max(20)
            .step(1)
            .onChange(() => estimatePoseLoop(true, guiState.net, guiState.yolo, guiState.mobile));
    gui.add(guiState, 'showKeypoints').onChange(drawMultiplePosesResults);
    gui.add(guiState, 'showSkeleton').onChange(drawMultiplePosesResults);
    gui.add(guiState, 'showBoundingBox').onChange(drawMultiplePosesResults);
}


// TAKEN FROM open source posenet_model.ts
async function loadMobileNet() {
  const outputStride = guiState.model.outputStride;
  const quantBytes = guiState.model.quantBytes;
  const multiplier = guiState.model.multiplier;

  if (tf == null) {
    throw new Error(
        `Cannot find TensorFlow.js. If you are using a <script> tag, please ` +
        `also include @tensorflow/tfjs on the page before using this
        model.`);
  }

  /*
  const url = mobileNetCheckpoint(outputStride, multiplier, quantBytes);
  const graphModel = await tfconv.loadGraphModel(config.modelUrl || url, 
                            {onProgress: p => console.log("yolo: loading ",Math.floor(p*100))});

  const mobilenet = new MobileNet(graphModel, outputStride);

  //const validInputResolution = getValidInputResolutionDimensions(
  //                                  config.inputResolution, mobilenet.outputStride);
  return new mobilenet;  // validInputResolution);
  */
}




/**
 * Kicks off the demo by loading the posenet model and estimating
 * poses on a default image
 */
var t0 = performance.now();
export async function loadAIModel() {
    var v3_tiny_model = null;
    var tfyolov3;
    //tf.ENV.set('WEBGL_PACK', false);        // debug: failed to compile fragment sharder bug





    var make = (INFO.device) ? INFO.device.make : "unk";   // race cond at startup




    var use_media_pipe = null;
    //if ((make === "ios") || (make === "mac") || (make === "android")) {
    if ((make === "ios") || (make === "mac")) {
        use_media_pipe = false;
    } else {
        use_media_pipe = INFO.use_media_pipe;
    }

    if (TIMES.ai_start > 0) {
        return INFO.model_promise;
    }
    TIMES.ai_start = Date.now();
    console.log("loadAIModel.376: Starting...", timeDelta(), "  admin=", INFO.admin_mode, " make=",make, " media_pipe=",use_media_pipe, " device_make=",make);
    
    //var gl = document.body.appendChild(document.createElement('canvas')).getContext('webgl')
    //await Reset(gl);      // NOG WORK: clean out webgl state, HW has limited textures
    await tf.setBackend("webgl");   // USE THIS: WebGL is frontend lib to use GPU

    /* WIP WASM SETUP: SETUP OK, RUNTIME HAS ERRORS
    // wasm code setup OK, but this kernal has missing calls like nearestNeighbor
    // need to add the wasm files to public after "yarn add"
    await setWasmPaths({
        'tfjs-backend-wasm.wasm': 'tfjs-backend-wasm.wasm',
        'tfjs-backend-wasm-simd.wasm': 'tfjs-backend-wasm-simd.wasm',
        'tfjs-backend-wasm-threaded-simd.wasm': 'tfjs-backend-wasm-threaded-simd.wasm'
    });
    console.log("loadAIModel.866: after wasm...")
    /**/

    var psnet = null;
    if(INFO.use_blazepose === true) {
        const BLAZEPOSE_POSE_MODEL = poseDetection.SupportedModels.BlazePose;    // BEST 2021 MODEL: BlazePose
        POSE_MODEL = BLAZEPOSE_POSE_MODEL;

        //     - sudo yarn add @mediapipe/pose
        //
        //const media_detectorConfig = {runtime: 'mediapipe', solutionPath: 'https://cdn.jsdelivr.net/npm/@mediapipe/pose@0.4',  modelType: 'lite'};  // WORKING: "@mediapipe/pose": "^0.5.1635988162",
        var mp_version = mpPose.VERSION;
        const media_detectorConfig = {runtime: 'mediapipe', solutionPath: 'https://cdn.jsdelivr.net/npm/@mediapipe/pose@'+mpPose.VERSION,  modelType: 'lite'};  // WORKING: "@mediapipe/pose": "^0.5.1635988162",
        
        // WORKING: "@tensorflow-models/pose-detection": "^0.0.6", ==> 2.0.0
        // WORKING:  "@tensorflow/tfjs": "^3.13.0", ==> 3.15.0
        // NOT_USING: import '@tensorflow/tfjs-backend-webgl'; // Register WebGL backend.
        //
        // REF: https://github.com/tensorflow/tfjs-models/tree/master/pose-detection/src/blazepose_tfjs
        //     - OLD:  sudo yarn add @tensorflow/ ----- tfjs ------

        //     - sudo yarn add @tensorflow-models/pose-detection
        //     - sudo yarn add @tensorflow/tfjs-core 
        //     - sudo yarn add @tensorflow/tfjs-converter 
        //     - sudo yarn add @tensorflow/tfjs-backend-webgl
        //
        // ALSO: Look at AnalyzeImage() => estimationConfig
        //     - npm view @tensorflow/tfjs-core versions    <<< find out what is available
        //
        const tfjs_detectorConfig = {runtime: 'tfjs', enableSmoothing: true, modelType: "lite"};    //WORKING:  posenet_3D
        var detectorConfig = (use_media_pipe === true) ? media_detectorConfig : tfjs_detectorConfig;

        psnet = await poseDetection.createDetector(
                        POSE_MODEL,
                        detectorConfig,
                    )
                    .then((model) => {
                        console.log("1571: # # # # # START warming up BLAZEPOSE    mediapipe=",INFO.use_media_pipe, " ver=",mp_version,"  t.delta=", timeDelta(t0), " model=", model);
                        var t2 = performance.now();
                        guiState.net = model;
                        INFO.pose_model = model;        // XXCD: where model is set
                        showLoadingMessage();

                        /*
                        const warmPose = model.estimatePoses(        // warm up the blazepose model
                                //tf.zeros([360, 270, 3]))        // did nothing
                                //tf.zeros([POSE_INPUT_SIZE, POSE_INPUT_SIZE, 3]))        // src says [128, 128, 3]?
                                .then((poses) => {
                                    console.log("warmup.blaze.1327:     ..................GOT WARMUP: ", poses);
                                    return poses
                                })
                                .catch((err) => {
                                    console.log("warmup.blaze.1331:     ..................WARMUP ERROR: ", err);
                                });

                        console.log("1320: BlazePose WARMED UP ", timeDelta(t2), "  model=",model);
                        */
                        return model;
                    })
                    .catch((err)=>{
                            console.log("blazepose.1325:  Error: ", err);
                    })

    } 
    
    // OBSOLETE:  KEEP AS LEGACY FOR NOW
    //
    else if (INFO.use_movenet === true) {
        // lib: https://github.com/tensorflow/tfjs-models/tree/master/pose-detection/src/movenet
        // app: https://github.com/tensorflow/tfjs-models/blob/master/pose-detection/demos/live_video/src/camera.js
        //
        const MOVENET_POSE_MODEL = poseDetection.SupportedModels.MoveNet; 
        POSE_MODEL = MOVENET_POSE_MODEL;
        const detectorConfig = {modelType: poseDetection.movenet.modelType.SINGLEPOSE_LIGHTNING};
        psnet = await poseDetection.createDetector(
                        poseDetection.SupportedModels.MoveNet,
                        detectorConfig
                    )
                    .then((pose) => {
                        //console.log("1174: start warming up posenet model", timeDelta(t0))
                        var t2 = performance.now();
                        guiState.net = pose;
                        INFO.pose_model = pose;
                        showLoadingMessage();

                        const warmPose = pose.estimatePoses(     // warm up the movenet model
                                tf.zeros([POSE_INPUT_SIZE, POSE_INPUT_SIZE, 3]));        // src says [128, 128, 3]?
                        console.log("1082: MoveNet WARMED UP ", timeDelta(t2), "  pose=",pose.moveNetModel.modelUrl);
                        return pose;
                   })
                   .catch((err)=>{
                        console.log("movenet.1350:  Error: ", err);
                   })
    } 
    


    // BALL & CONE MODEL:  load yolo-v3 + mobilenet-v2 model
    var t3 = performance.now();
    if(SOCCER_MODEL) {
        v3_tiny_model = './models/model.json';   // WORKS: converted from .pb frozen_model
        //tfyolov3 = tf.loadGraphModel(v3_tiny_model, {onProgress: p => console.log("yolo: loading ",Math.floor(p*100))})
        tfyolov3 = tf.loadGraphModel(v3_tiny_model, {onProgress: p => showLoadingMessage(p)})
                    /***/
                   .then( (yolo) => {
                        //console.log("1201: start warming up yolo model ", timeDelta(t3))
                        var t4 = performance.now();
                        guiState.yolo = yolo;
                        INFO.ball_model = yolo;

                        const warmYolo = yolo.predict(tf.zeros([1, YOLO_INPUT_SIZE, YOLO_INPUT_SIZE, 3]));   // warm up the model
                        warmYolo.dataSync();
                        warmYolo.dispose();
                        console.log("1186: Yolo model warmed up!  ", timeDelta(t0));
                        showLoadingMessage();
                        return yolo;
                   })
                   /**/

    } else {
        v3_tiny_model = 'https://raw.githubusercontent.com/shaqian/tfjs-yolo-demo/master/dist/model/v3tiny/model.json';
        tfyolov3 = tf.loadLayersModel(v3_tiny_model);   // NOT USED: Can not conver from Keras
    }


    console.log("loadAIModel.494: after yolov3=", tfyolov3, "  time=", timeDelta());

    // load coco + ssd + mobilenet-v2
    //const mobilev2 = await cocoSSD.load('lite_mobilenet_v2');   // WORKING: SSD + mobilenet
    //const mobilev2 = await mobilenet.load({version: 2, alpha: 1.0});  // DO NOT USE: classify ONLY
    var mobilev2 = null;

    showLoadingMessage();
    var out = Promise.all([ psnet, tfyolov3 ]).then((values) => {
        // kludge: https://stackoverflow.com/questions/64063914/unknown-regularizer-l2-in-tensorflowjs
        class L2 { 
            static className = 'L2'; 
            constructor(config) {
                return tf.regularizers.l1l2(config)
            }
        }
        tf.serialization.registerClass(L2);     // bypass bug from loading custom model convert from python

        if(INFO.admin_mode == true) {
            gui = new dat.GUI();
            toggleLoadingUI(true);
            setupGui(psnet, tfyolov3, mobilev2);
            toggleLoadingUI(false);
        } 

        showLoadingMessage();
        TIMES.ai_loaded = Date.now();
        return values;
    });

    INFO.model_promise = out;
    return out;

}

export { estimatePoseLoop }
